
App.directive('appFilespopup', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/filespopup.html',
        restrict: 'E',
        replace: true,
        controller: 'FilesPopupController',
        scope: {
            icon: '=',
            label: '=',
            type: '@',
            field: '@',
            entity: '@',
            showIfEmpty: '@'
        }
    };
  
  });